import { CalculatorId } from '../../../lib/calculators/calculator-config';
import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';

export const coefficientOfDeterminationDescription: CalculatorDescription = {
  id: CalculatorId.COEFFICIENT_OF_DETERMINATION,
  title: 'Coefficient of Determination (R²) Calculator',
  metaTitle: 'Online R² Calculator - Measure Goodness of Fit in Regression Analysis',
  description: 'Calculate the coefficient of determination (R²) to measure how well a regression model fits your data. Includes adjusted R² and visual analysis.',
  metaDescription: 'Calculate R² and adjusted R² online. Measure the goodness of fit of your regression model with our free calculator. Visualize and interpret results.',
  howTo: {
    title: 'How to Use the R² Calculator',
    steps: [
      'Enter paired data values for your independent (X) and dependent (Y) variables',
      'Select your variables from the dropdown menus',
      'View the R² and adjusted R² values',
      'Interpret the strength of the relationship',
      'Analyze the scatter plot with regression line'
    ],
    graphic: {
      description: 'A scatter plot showing data points and regression line, with R² value and interpretation'
    }
  },
  examples: [
    {
      title: 'Marketing ROI Analysis',
      description: 'Analyzing the relationship between advertising spend and sales revenue',
      dataDescription: 'Monthly advertising costs and corresponding sales figures',
      insights: [
        'Measures marketing effectiveness',
        'Quantifies variance explained by advertising',
        'Helps optimize marketing budget',
        'Predicts sales performance'
      ]
    },
    {
      title: 'Academic Performance Study',
      description: 'Examining the relationship between study hours and test scores',
      dataDescription: 'Weekly study hours and corresponding exam scores',
      insights: [
        'Evaluates study effectiveness',
        'Identifies learning patterns',
        'Guides study strategies',
        'Predicts academic outcomes'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.CORRELATION_COEFFICIENT,
    CalculatorId.COVARIANCE
  ]
}; 